import { NgModule } from '@angular/core';
import { DateFormatDistancePipe, DateFormatPipe } from '@pipes/dateFns.pipe';
import { SortByPipe } from '@pipes/sorts.pipe';
import { getAssetsPath } from '@pipes/getAssetsPath';
import { groupByKeyPipe } from '@pipes/groupByKey.pipe';
import { BalanceFormatPipe, CashoutBalance } from '@pipes/balanceFormat.pipe';
import { getEnv } from '@pipes/getEnv.pipe';
import { getProductName } from '@pipes/getProductName.pipe';
import { WalletControl } from '@pipes/walletControl.pipe';
import { CommonModule } from '@angular/common';
import { DeepValuePipe } from '@pipes/deepValue.pipe';
import { oddFormatPipe } from '@app/pipes/oddFormat.pipe';
import { HttpClient } from '@angular/common/http';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { OutsideListener } from '@app/directives/outside.listener.directive';
import { HttpLoaderFactory, MyMissingTranslationHandler } from '@app/utils/translation.utils';
import { GroupBySportId } from '@app/pipes/groupbysportid';
import { GroupByEventName } from '@app/pipes/groupbyeventname.pipe';
import { GroupByTournamentId } from '@app/pipes/grouplivefixturebytournamentid';
import { GroupOddsByName } from '@pipes/groupoddsbyname.pipe';
import { GroupLiveOddsByName } from '@pipes/groupliveoddsbyname.pipe';
import { GroupByMatchId } from '@pipes/groupbymatchid';
import { GroupOutrightOddsByName } from '@pipes/groupoutrightsoddsbyname.pipe';
import { FavoriesPipe } from '@pipes/favories.pipe';
import { IsoCountriesPipe } from '@pipes/isoCountries.pipe';
import { GroupByTournamentName } from '@pipes/tournament_name';
import { GroupByName } from '@pipes/groupbyname.pipe';
import { removeUniquePipe } from '@pipes/reducer.pipe';
import { FiltersPipe } from '@pipes/filters.pipe';

@NgModule({
  declarations: [
    GroupBySportId,
    GroupByEventName,
    GroupByTournamentId,
    DateFormatPipe,
    DateFormatDistancePipe,
    SortByPipe,
    groupByKeyPipe,
    getAssetsPath,
    groupByKeyPipe,
    BalanceFormatPipe,
    oddFormatPipe,
    getEnv,
    getProductName,
    WalletControl,
    CashoutBalance,
    DeepValuePipe,
    OutsideListener,
    GroupOddsByName,
    GroupLiveOddsByName,
    GroupByMatchId,
    GroupOutrightOddsByName,
    FavoriesPipe,
    IsoCountriesPipe,
    GroupByTournamentName,
    GroupByName,
    removeUniquePipe,
    FiltersPipe,
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
      extend: true,
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
      useDefaultLang: true,
    }),
  ],
  providers: [],
  exports: [
    FiltersPipe,
    removeUniquePipe,
    GroupByName,
    GroupByTournamentName,
    IsoCountriesPipe,
    GroupOutrightOddsByName,
    GroupByMatchId,
    GroupBySportId,
    DateFormatPipe,
    DateFormatDistancePipe,
    SortByPipe,
    GroupLiveOddsByName,
    groupByKeyPipe,
    getAssetsPath,
    groupByKeyPipe,
    BalanceFormatPipe,
    oddFormatPipe,
    getEnv,
    getProductName,
    WalletControl,
    CashoutBalance,
    DeepValuePipe,
    TranslateModule,
    OutsideListener,
    GroupByEventName,
    GroupByTournamentId,
    GroupOddsByName,
    FavoriesPipe,
  ],
})
export class SharedModule {}
